import React, { useState, useCallback, useEffect } from "react";
import Dropzone from "react-dropzone";
import Cropper from "react-easy-crop";
import getCroppedImg from "../../../../commonComponents/upload-crop-img/getCroppedImg";
import { useDispatch, useSelector } from "react-redux";
import jwt_decode from "jwt-decode";
import LocationSearchBar from "../../../../commonComponents/navBar/locationSearchBar";
import { useNavigate } from "react-router-dom";
import "./uploadCover.scss";

const UploadCover = () => {
  const navigate = useNavigate();
  const [imageUrl, setImage] = useState(null);
  const [CrppedImageUrl, setCrppedImage] = useState(null);
  const [hideCropper, setHideCropper] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const userState = useSelector((state) => state.userReducer);
  const restaurantState = useSelector((state) => state.restaurantReducer);
  const [responseFromSever, setResponseFromSever] = useState("");
  const [errorFromSever, setErrorFromSever] = useState("");

  const onDrop = useCallback((acceptedFiles) => {
    setHideCropper(false);
    const file = acceptedFiles[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      console.log("bbbb", reader.result);
      setImage(reader.result);
    };
  }, []);

  const onCropChange = (crop) => {
    setCrop(crop);
  };

  const onZoomChange = (zoom) => {
    setZoom(zoom);
  };

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const onCrop = async () => {
    const croppedImageUrl = await getCroppedImg(imageUrl, croppedAreaPixels);
    setCrppedImage(croppedImageUrl);
    console.log({ croppedImageUrl });
    setHideCropper(true);
  };
  const onCancel = () => {
    setHideCropper(true);
  };

  const nextPhaseToAddRestaurant = () => {
    let restaurantAddress = null;
    if (token === null) {
      restaurantAddress = userState.address;
    } else {
      const decodedToken = jwt_decode(token);
      if (
        decodedToken.address.label !== userState.address.label &&
        userState.address.label !== ""
      ) {
        restaurantAddress = userState.address;
      } else {
        restaurantAddress = decodedToken.address;
      }
    }
    console.log({ restaurantAddress });
    console.log(CrppedImageUrl);

    if (restaurantAddress && CrppedImageUrl) {
      console.log(CrppedImageUrl, restaurantAddress);
      dispatch({
        type: "ADD_COVER_ADDRESS",
        payload: {
          location: restaurantAddress,
          cover: CrppedImageUrl,
        },
      });
      console.log(CrppedImageUrl);
      console.log("typeof CrppedImageUrl", typeof CrppedImageUrl);
      console.log({ restaurantState });

      const formData = new FormData();
      formData.append("cover", CrppedImageUrl, restaurantState.restaurant_name);
      formData.append("restaurant_name", restaurantState.restaurant_name);
      formData.append("phone", restaurantState.phone);
      formData.append(
        "restaurant_category",
        restaurantState.restaurant_category
      );
      formData.append("restaurant_review", 5);
      formData.append("address", JSON.stringify(restaurantAddress));
      fetch("https://femez.onrender.com/API/restaurant/addRestaurant", {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
          enctype: "multipart/form-data",
        },
      })
        .then((response) => {
          if (!response.ok) {
            return response.json().then((errorData) => {
              throw new Error(
                errorData.message || "Network response was not ok"
              );
            });
          }
          return response.json();
        })
        .then((data) => {
          localStorage.setItem("restaurant_existence", true);
          console.log(data.message);
          setResponseFromSever(data.message);
          setErrorFromSever("");
          setTimeout(() => {
            navigate(`/restaurant/myRestaurant`);
          }, 1000);
        })
        .catch((error) => {
          console.error("Error:", error.message);

          // Check if the error response contains a JSON body with a message
          if (error.response && error.response.json) {
            error.response.json().then((errorMessage) => {
              setResponseFromSever("");

              setErrorFromSever(errorMessage.message);
              // alert(errorMessage.message);
            });
          } else {
            setResponseFromSever("");
            setErrorFromSever(error.message);
          }
        });
      // .then((response) => {
      //   // Check if the response status is in the success range (200-299)
      //   if (response.ok) {
      //     return response.json(); // Parse the JSON response
      //   } else {
      //     console.log(response.message);
      //     throw new Error("Network response was not ok");
      //   }
      // })
      // .then((data) => {
      //   if (data.error) {
      //     console.log(data.error);
      //     setErrorFromSever(data.error);
      //     // Display the error message to the user (e.g., update UI or show a notification)
      //   } else {
      //     localStorage.setItem("restaurant_existence", true);
      //     setResponseFromSever(data.message);
      //   }
      // })
      // .catch((error) => {
      //   console.error("ffffffffffffffffffffffff", error.message);
      //   //   if (
      //   //     error.response &&
      //   //     error.response.data &&
      //   //     error.response.data.error
      //   //   ) {
      //   //     setErrorFromSever(error.response.data.error);
      //   //   } else {
      //   //     setErrorFromSever("An error occurred.");
      //   //   }
      // });
    }
  };

  useEffect(() => {
    // Check if the page was refreshed
    const wasRefreshed = localStorage.getItem("refreshed_restaurant");
    if (wasRefreshed) {
      // Clear the flag in local storage
      localStorage.removeItem("refreshed_restaurant");
      // Navigate to the desired route
      navigate("/restaurant/addRestaurant");
    }

    // Set the flag in local storage to detect future refreshes
    localStorage.setItem("refreshed_restaurant", "true");

    // Clean up the local storage flag when the component unmounts
    return () => {
      localStorage.removeItem("refreshed_restaurant");
    };
  }, [navigate]);

  return (
    <div className="upload-cover-container">
      <div className="restaurant-address">
        <h1>Restaurant Address</h1>
        <LocationSearchBar />
      </div>
      <div className="upload-cover-bar">
        <h1>Restaurant Cover</h1>
        <Dropzone onDrop={onDrop}>
          {({ getRootProps, getInputProps }) => (
            <div className="upload-cover" {...getRootProps()}>
              <input {...getInputProps()} />
              Drag and drop here your restaurant cover, or click to select
            </div>
          )}
        </Dropzone>
        {imageUrl && !hideCropper && (
          <div className="cropper" id="cropper">
            <Cropper
              image={imageUrl}
              zoom={zoom}
              crop={crop}
              aspect={1000 / 200}
              onCropChange={onCropChange}
              onZoomChange={onZoomChange}
              onCropComplete={onCropComplete}
            />

            <div style={{ zIndex: 5 }} className="cropper-buttons-slider">
              <div style={{ zIndex: 5 }} className="cropper-slider">
                <p>Zoom </p>

                <input
                  type="range"
                  min={1}
                  max={3}
                  step={0.1}
                  value={zoom}
                  onInput={(e) => {
                    onZoomChange(e.target.value);
                  }}
                  className="slider"
                ></input>
              </div>
              <div className="cropper-buttons">
                <button onClick={onCrop}>Crop</button>
                <button onClick={onCancel}>Cancel</button>
              </div>
            </div>
          </div>
        )}
        {CrppedImageUrl && (
          <div className="cropped-image">
            <img
              src={URL.createObjectURL(CrppedImageUrl)}
              alt="restaurant cover"
              style={{ width: "1000px", height: "200px" }}
            ></img>
            <button onClick={nextPhaseToAddRestaurant}>
              Create Your Restaurant
            </button>
            <p style={{ color: "red" }}>{errorFromSever}</p>
            <p style={{ color: "green" }}>{responseFromSever}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UploadCover;
